import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { formatToPhone } from 'brazilian-values';
import { useAuth } from '../../../../hooks/Auth';
import { parseCpfCnpj, parsePhone } from '../../../../helpers/parseValues';
import { StepButtons } from '../StepButtons';
import {
  Title,
  Paragraph,
  BtnWrapper,
  FixedButton,
  InputContainerWidthNumber,
  SectionTitle,
  SectionTitleContainer,
  FieldsInLineLayout
} from './styled';
import { useManager } from '../../../../hooks/Manager';
import { usePickup } from '../../../../hooks/Pickup';
import { DefaultCollectContext } from '../..';

export const RequesterData = () => {
  const [variousDestinations, setVariousDestinations] = useState(false);
  const [numberDestinations, setNumberDestinations] = useState('');
  const [isRequiredAlternativeContact, setIsRequiredAlternativeContact] =
    useState(false);
  const [isRequiredAlternativeContact2, setIsRequiredAlternativeContact2] =
    useState(false);
  const [variousDestinationsEnable, setVariousDestinationsEnable] =
    useState(false);

  const { user } = useAuth();

  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    setSteps,
    handleNextStep,
    addressList,
    requester,
    setRequester,
    hasVariousDestinations,
    setHasVariousDestinations,
    destinationQuantity,
    setDestinationQuantity,
    requesterContact,
    collectRequesterData,
    setCollectRequesterData,
    setCollectSenderData,
    setCollectRecipientData,
    collectContactData,
    setCollectContactData,
    contactName,
    setContactName,
    contactEmail,
    setContactEmail,
    phoneNumber,
    setPhoneNumber,
    contactRamal,
    setContactRamal,
    alternativeContactName,
    setAlternativeContactName,
    alternativeContactEmail,
    setAlternativeContactEmail,
    alternativeContactPhone,
    setAlternativeContactPhone,
    alternativeContactExtension,
    setAlternativeContactExtension,
    alternativeContactName2,
    setAlternativeContactName2,
    alternativeContactEmail2,
    setAlternativeContactEmail2,
    alternativeContactPhone2,
    setAlternativeContactPhone2,
    alternativeContactExtension2,
    setAlternativeContactExtension2,
    alternativeContact,
    setAlternativeContact,
    alternativeContact2,
    setAlternativeContact2
  } = useContext(DefaultCollectContext);

  const collectRequesterSchema = Yup.object().shape({
    requesterType: Yup.string().oneOf(
      ['sender', 'recipient'],
      'Informe o tipo do solicitante'
    ),
    contactName: Yup.string().required('Nome obrigatório'),
    contactEmail: Yup.string()
      .required('E-mail obrigatório')
      .trim('E-mail obrigatório')
      .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido'),
    phoneNumber: Yup.string()
      .required('Telefone obrigatório')
      .trim('Telefone obrigatório')
      .test('validatePhoneNumber', 'Telefone inválido', (value) =>
        value ? parsePhone(value).length >= 10 : false
      ),
    extension: Yup.string().nullable(),
    alternativeContact: Yup.boolean(),

    alternativeContactName: isRequiredAlternativeContact
      ? Yup.string().required('Nome obrigatório')
      : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactEmail: isRequiredAlternativeContact ? Yup.string().required('E-mail obrigatório').matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido') : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactPhone: isRequiredAlternativeContact ? Yup.string().required('Telefone obrigatório').test('validatePhoneNumber', 'Telefone inválido', (value) => value ? parsePhone(value).length >= 10 : false) : Yup.string().nullable(),
    alternativeExtension: Yup.string().nullable(),

    alternativeContactName2: isRequiredAlternativeContact2
      ? Yup.string().required('Nome obrigatório')
      : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactEmail2: isRequiredAlternativeContact2 ? Yup.string().required('E-mail obrigatório').matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido') : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactPhone2: isRequiredAlternativeContact2 ? Yup.string().required('Telefone obrigatório').test('validatePhoneNumber', 'Telefone inválido', (value) => value ? parsePhone(value).length >= 10 : false) : Yup.string().nullable(),
    alternativeExtension2: Yup.string().nullable()
  });

  const {
    handleSubmit,
    control,
    setValue,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(collectRequesterSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });

  const { getPickupManagerBranchValidations } = useManager();
  const { branchParameterizationId } = usePickup();

  const getValidation = async () => {
    const branchValidations = await getPickupManagerBranchValidations({
      branchParameterizationId
    });
    const validationsVarious = branchValidations
      ? branchValidations[0]?.enableMultipleDestinationsSameRequest
      : '';

    if (validationsVarious === true) {
      setVariousDestinationsEnable(true);
    } else if (validationsVarious === false) {
      setVariousDestinationsEnable(false);
    }
  };

  useEffect(() => {
    getValidation();
  }, []);

  const onNextStep = (data) => {
    if (variousDestinations && !numberDestinations) {
      setError('numberDestinations', { message: 'Quantidade obrigatória' });

      return;
    }

    setHasVariousDestinations(variousDestinations);
    setDestinationQuantity(numberDestinations);

    setCollectRequesterData({
      requesterType: requester,
      document: parseCpfCnpj(String(user.document)),
      name: user.name,
      address: {
        zipPostalCode: parseCpfCnpj(String(addressList[0].zipPostalCode)),
        streetAddress: addressList[0].streetAddress,
        streetAddressNumber: parsePhone(
          String(addressList[0].streetAddressNumber)
        ),
        suburb: addressList[0].suburb,
        city: addressList[0].city,
        state: addressList[0].state,
        country: addressList[0].country || 'BRASIL',
        additionalInformation: addressList[0].additionalInformation || ''
      },
      contactList: [
        {
          name: addressList[0].contactName,
          phoneNumber: addressList[0].contactNumber,
          extension: addressList[0].contactExtension,
          email: addressList[0].contactEmail
        }
      ]
    });

    if (requester === 'recipient') {
      setCollectRecipientData({
        document: parseCpfCnpj(user.document),
        name: user.name,
        address: {
          zipPostalCode: parseCpfCnpj(addressList[0].zipPostalCode),
          streetAddress: addressList[0].streetAddress,
          streetAddressNumber: addressList[0].streetAddressNumber,
          suburb: addressList[0].suburb,
          city: addressList[0].city,
          state: addressList[0].state,
          country: addressList[0].country || 'BRASIL',
          additionalInformation: addressList[0].additionalInformation || ''
        },
        contactList: [
          {
            name: addressList[0].contactName,
            phoneNumber: addressList[0].contactNumber,
            extension: addressList[0].contactExtension,
            email: addressList[0].contactEmail
          }
        ]
      });
    }

    const contactList = [];

    contactList.push({
      name: data.contactName,
      phoneNumber: parsePhone(data.phoneNumber),
      extension: data.extension,
      email: data.contactEmail
    });

    alternativeContact &&
      isRequiredAlternativeContact &&
      contactList.push({
        name: data.alternativeContactName,
        phoneNumber: parsePhone(data.alternativeContactPhone),
        extension: data.alternativeExtension,
        email: data.alternativeContactEmail
      });

    alternativeContact2 &&
      isRequiredAlternativeContact2 &&
      contactList.push({
        name: data.alternativeContactName2,
        phoneNumber: parsePhone(data.alternativeContactPhone2),
        extension: data.alternativeExtension2,
        email: data.alternativeContactEmail2
      });

    setCollectContactData(contactList);

    handleNextStep();
  };

  useEffect(() => {
    if (
      alternativeContactName !== '' ||
      alternativeContactEmail !== '' ||
      alternativeContactPhone !== ''
    ) {
      setAlternativeContact(true);
    }

    if (
      alternativeContactName2 !== '' ||
      alternativeContactEmail2 !== '' ||
      alternativeContactPhone2 !== ''
    ) {
      setAlternativeContact2(true);
    }
  }, []);

  const addContact = () => {
    if (alternativeContact === true) {
      setAlternativeContact2(true);
    }

    if (alternativeContact === false) {
      setAlternativeContact(true);
    }
  };

  const handleChangeCheckbox = (event) => {
    setVariousDestinations(event.target.checked);
    if (event.target.checked) {
      setNumberDestinations(2);
    } else {
      setNumberDestinations('');
      setValue('numberDestinations', '');
      clearErrors(['numberDestinations']);
    }
  };

  useEffect(() => {
    setValue('requesterType', requester);

    if (requester === 'sender') {
      localStorage.setItem('@Braspress:requesterType', 'sender');
      setSteps([
        'Dados do Solicitante',
        'Dados da Coleta',
        'Dados da Carga',
        'Informações Fiscais'
      ]);
    } else if (requester === 'recipient') {
      localStorage.setItem('@Braspress:requesterType', 'recipient');
      setSteps([
        'Dados do Solicitante',
        'Dados da Coleta',
        'Dados da Carga',
        'Informações Fiscais'
      ]);
    }
  }, [requester]);

  useEffect(() => {
    const clear = [];

    if (requesterContact.contactName) {
      setValue('contactName', requesterContact.contactName.toUpperCase());
      setContactName(requesterContact.contactName.toUpperCase());
      clear.push('contactName');
    }

    if (requesterContact.contactEmail) {
      setValue('contactEmail', requesterContact.contactEmail.toLowerCase());
      setContactEmail(requesterContact.contactEmail.toLowerCase());
      clear.push('contactEmail');
    }

    if (requesterContact.phoneNumber) {
      setValue('phoneNumber', requesterContact.phoneNumber);
      setPhoneNumber(requesterContact.phoneNumber);
      clear.push('phoneNumber');
    }

    if (requesterContact.extension) {
      setValue('extension', requesterContact.extension);
      clear.push('extension');
    }

    clearErrors(clear);
  }, [JSON.stringify(requesterContact)]);

  // useEffect(() => {
  //   $('#phoneNumber').mask('(00) 0000-00009');
  // }, [phoneNumber]);

  // useEffect(() => {
  //   $('#alternativeContactPhone').mask('(00) 0000-00009');
  // }, [alternativeContactPhone]);

  // useEffect(() => {
  //   $('#alternativeContactPhone2').mask('(00) 0000-00009');
  // }, [alternativeContactPhone2]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    $('#phoneNumber').mask('(00) 0000-00009');
    // eslint-disable-next-line
    $('#phoneNumber').blur(function (event) {
      if ($(this).val().length === 15) {
        // Celular com 9 dígitos + 2 dígitos DDD e 4 da máscara
        $(this).mask('(00) 00000-0009');
      } else {
        $(this).mask('(00) 0000-00009');
      }
    });

    // eslint-disable-next-line no-unused-expressions
    $('#alternativeContactPhone').mask('(00) 0000-00009');
    // eslint-disable-next-line
    $('#alternativeContactPhone').blur(function (event) {
      if ($(this).val().length === 15) {
        // Celular com 9 dígitos + 2 dígitos DDD e 4 da máscara
        $(this).mask('(00) 00000-0009');
      } else {
        $(this).mask('(00) 0000-00009');
      }
    });

    $('#alternativeContactPhone2').mask('(00) 0000-00009');
    // eslint-disable-next-line
    $('#alternativeContactPhone2').blur(function (event) {
      if ($(this).val().length === 15) {
        // Celular com 9 dígitos + 2 dígitos DDD e 4 da máscara
        $(this).mask('(00) 00000-0009');
      } else {
        $(this).mask('(00) 0000-00009');
      }
    });
  }, [alternativeContact, alternativeContact2, phoneNumber]);

  const removeContactAlternative = () => {
    setAlternativeContactName('');
    setAlternativeContactEmail('');
    setAlternativeContactPhone('');
    setAlternativeContactExtension('');
    setValue('alternativeContactName', '');
    setValue('alternativeContactEmail', '');
    setValue('alternativeContactPhone', '');
    setValue('alternativeContactExtension', '');
  };

  const removeContactAlternative2 = () => {
    setAlternativeContactName2('');
    setAlternativeContactEmail2('');
    setAlternativeContactPhone2('');
    setAlternativeContactExtension2('');
    setValue('alternativeContactName2', '');
    setValue('alternativeContactEmail2', '');
    setValue('alternativeContactPhone2', '');
    setValue('alternativeContactExtension2', '');
  };

  useEffect(() => {
    if (
      alternativeContactName !== '' ||
      alternativeContactEmail !== '' ||
      alternativeContactPhone !== '' ||
      alternativeContactExtension !== ''
    ) {
      setIsRequiredAlternativeContact(true);
    } else {
      setIsRequiredAlternativeContact(false);
      clearErrors([
        'alternativeContactName',
        'alternativeContactEmail',
        'alternativeContactPhone'
      ]);
    }
  }, [
    alternativeContactName,
    alternativeContactEmail,
    alternativeContactPhone,
    alternativeContactExtension
  ]);

  useEffect(() => {
    if (
      alternativeContactName2 !== '' ||
      alternativeContactEmail2 !== '' ||
      alternativeContactPhone2 !== '' ||
      alternativeContactExtension2 !== ''
    ) {
      setIsRequiredAlternativeContact2(true);
    } else {
      setIsRequiredAlternativeContact2(false);
      clearErrors([
        'alternativeContactName2',
        'alternativeContactEmail2',
        'alternativeContactPhone2'
      ]);
    }
  }, [
    alternativeContactName2,
    alternativeContactEmail2,
    alternativeContactPhone2,
    alternativeContactExtension2
  ]);

  useEffect(() => {
    $('#addressListZipPostalCode').mask('00000-000');

    collectRequesterData.requesterType &&
      setValue('requesterType', collectRequesterData.requesterType);

    setVariousDestinations(hasVariousDestinations);
    setNumberDestinations(destinationQuantity);

    if (collectContactData.length > 0) {
      setValue('contactName', collectContactData[0].name.toUpperCase());
      setValue('contactEmail', collectContactData[0].email.toLowerCase());
      setValue('phoneNumber', collectContactData[0].phoneNumber);
      setPhoneNumber(collectContactData[0].phoneNumber);
      setValue('extension', collectContactData[0].extension);
    }

    if (collectContactData.length > 1) {
      setAlternativeContact(true);
      setIsRequiredAlternativeContact(true);
      setValue(
        'alternativeContactName',
        collectContactData[1].name.toUpperCase()
      );
      setValue(
        'alternativeContactEmail',
        collectContactData[1].email.toLowerCase()
      );
      setValue('alternativeContactPhone', collectContactData[1].phoneNumber);
      setValue('alternativeExtension', collectContactData[1].extension);
    } else {
      setAlternativeContact(false);
    }

    if (collectContactData.length > 2) {
      setAlternativeContact2(true);
      setIsRequiredAlternativeContact2(true);
      setValue(
        'alternativeContactName2',
        collectContactData[1].name.toUpperCase()
      );
      setValue(
        'alternativeContactEmail2',
        collectContactData[1].email.toLowerCase()
      );
      setValue('alternativeContactPhone2', collectContactData[1].phoneNumber);
      setValue('alternativeExtension2', collectContactData[1].extension);
    } else {
      setAlternativeContact2(false);
    }
  }, []);

  return (
    <form onSubmit={handleSubmit(onNextStep)}>
      <Paper
        elevation={2}
        style={{
          position: 'relative',
          marginTop: 16,
          padding: '20px 16px 16px'
        }}
      >
        <Title style={{ marginBottom: 16 }}>Dados do Solicitante:</Title>

        <Stack
          direction={maxMD ? 'column' : 'row'}
          spacing={2}
          style={{ marginBottom: 16 }}
        >
          <Box>
            <Stack
              direction={maxMD ? 'column' : 'row'}
              spacing={maxMD ? 1 : 2}
              style={{ alignItems: maxMD ? 'inherit' : 'center' }}
            >
              <p>Solicitante:</p>

              <Controller
                control={control}
                defaultValue=""
                name="requesterType"
                render={({ field }) => {
                  return (
                    <RadioGroup
                      {...field}
                      style={{ flexDirection: 'row', gap: 16 }}
                    >
                      <FormControlLabel
                        value="sender"
                        label="Remetente"
                        control={
                          <Radio data-testid="senderRequesterRadioInput" />
                        }
                        checked={requester === 'sender'}
                        onChange={() => {
                          setRequester('sender');
                          setValue('requesterType', 'sender');
                          setCollectRecipientData({});
                        }}
                      />
                      <FormControlLabel
                        value="recipient"
                        label="Destinatário"
                        control={
                          <Radio data-testid="recipientRequesterRadioInput" />
                        }
                        checked={requester === 'recipient'}
                        onChange={() => {
                          setRequester('recipient');
                          setValue('requesterType', 'recipient');
                          setCollectSenderData({});
                        }}
                      />
                    </RadioGroup>
                  );
                }}
              />
            </Stack>

            <FormHelperText error={!!errors.requesterType}>
              {errors.requesterType?.message}
            </FormHelperText>
          </Box>

          <Stack
            direction="row"
            spacing={2}
            style={{ display: 'flex', alignItems: 'flex-start' }}
          >
            <Controller
              name="variousDestinations"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <FormControlLabel
                  label="Vários Destinos"
                  control={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Checkbox
                      data-testid="variousDestinationsCheckboxInput"
                      {...field}
                      disabled={
                        requester !== 'sender' ||
                        variousDestinationsEnable === false
                      }
                      // || variousDestinationsEnable === false
                      checked={!!variousDestinations && requester === 'sender'}
                      onChange={handleChangeCheckbox}
                      style={{ marginLeft: 0 }}
                    />
                  }
                />
              )}
            />

            <Controller
              name="numberDestinations"
              defaultValue=""
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  type="number"
                  label={`Quantidade${
                    variousDestinations && requester === 'sender' ? ' *' : ''
                  }`}
                  size="small"
                  style={{ width: 160 }}
                  data-testid="quantityDestinyInput"
                  value={(field.value = numberDestinations)}
                  onChange={(event) => {
                    const { value } = event.target;
                    const regex = /^[0-9]+$/;

                    if ((!value.match(regex) || value < 2) && value !== '') {
                      return;
                    }

                    setNumberDestinations(value);
                    field.onChange(value);
                  }}
                  disabled={!variousDestinations || requester !== 'sender'}
                  error={!!errors.numberDestinations}
                  helperText={errors.numberDestinations?.message}
                />
              )}
            />
          </Stack>
        </Stack>

        <Paragraph>
          {addressList[0]?.name} - {addressList[0]?.document}
        </Paragraph>
        <Paragraph>
          CEP:{' '}
          <span id="addressListZipPostalCode">
            {addressList[0]?.zipPostalCode}
          </span>
          , {addressList[0]?.streetAddress}
          {addressList[0]?.streetAddressNumber &&
            `, ${addressList[0]?.streetAddressNumber}`}
          {addressList[0]?.additionalInformation &&
            `, ${addressList[0]?.additionalInformation}`}
          , {addressList[0]?.suburb}, {addressList[0]?.city}-
          {addressList[0]?.state}
        </Paragraph>
        <Paragraph>
          CONTATO: {addressList[0]?.contactName}
          {addressList[0]?.contactNumber !== '' && (
            <>, {addressList[0]?.contactNumber}</>
          )}
          {addressList[0]?.contactExtension &&
            `, RAMAL ${addressList[0]?.contactExtension}`}
          , {addressList[0]?.contactEmail || addressList[0]?.email}
        </Paragraph>

        <Stack
          direction={maxSM ? 'column' : 'row'}
          spacing={maxSM ? 1 : 0}
          style={{
            height: !maxSM && 36.5,
            justifyContent: 'space-between',
            alignItems: maxSM ? 'inherit' : 'center',
            marginTop: 24,
            marginBottom: 16
          }}
        >
          <Title>Contato:</Title>

          <BtnWrapper>
            <FixedButton
              type="button"
              onClick={() => addContact()}
              disabled={!!(alternativeContact && alternativeContact2)}
              variant="contained"
              className="btnResponsive"
            >
              Adicionar Contato Alternativo
            </FixedButton>
          </BtnWrapper>
        </Stack>
        <FieldsInLineLayout className="lineResponsive">
          <Controller
            name="contactName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                type="text"
                id="contact_name"
                label="Nome *"
                data-testid="requesterContactNameInput"
                value={(field.value = contactName)}
                onChange={(e) => {
                  const { value } = e.target;
                  const regex = /^[aA-zZ\s]+$/;
                  if (!value.match(regex) && value !== '') {
                    return;
                  }
                  field.onChange(value.toUpperCase());
                  setContactName(e.target.value);
                }}
                onBlur={(e) => {
                  field.onBlur(field.onChange(e.target.value.toUpperCase()));
                }}
                error={!!errors?.contactName?.message}
                helperText={errors?.contactName?.message}
                fullWidth
                inputProps={{
                  maxLength: 256,
                  style: { textTransform: 'uppercase' }
                }}
              />
            )}
          />
          <Controller
            name="contactEmail"
            control={control}
            render={({ field }) => (
              <TextField
                id="contact_mail"
                label="E-mail *"
                type="email"
                {...field}
                data-testid="requesterContactEmailInput"
                value={(field.value = contactEmail)}
                onChange={(e) => {
                  setContactEmail(e.target.value);
                  field.onChange(e.target.value);
                }}
                onBlur={(e) => {
                  setContactEmail(e.target.value.toLowerCase());
                  field.onBlur(field.onChange(e.target.value.toLowerCase()));
                }}
                error={!!errors?.contactEmail?.message}
                helperText={errors?.contactEmail?.message}
                fullWidth
                inputProps={{ maxLength: 256 }}
              />
            )}
          />
          <Controller
            name="phoneNumber"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                id="phoneNumber"
                label="DDD + Telefone *"
                value={(field.value = formatToPhone(phoneNumber))}
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                  field.onChange(e.target.value);
                }}
                onBlur={(e) => {
                  if (e.target.value.length > 14) {
                    $('#phoneNumber').mask('(00) 00000-0009');
                  } else {
                    $('#phoneNumber').mask('(00) 0000-00009');
                  }
                  field.onBlur(field.onChange(e.target.value));
                  setPhoneNumber(e.target.value);
                }}
                error={!!errors?.phoneNumber?.message}
                helperText={errors?.phoneNumber?.message}
                fullWidth
                inputProps={{ maxLength: 50 }}
                className="telResponsive"
              />
            )}
          />
          <InputContainerWidthNumber>
            <Controller
              name="extension"
              control={control}
              render={({ field }) => (
                <TextField
                  id="contact_ramal"
                  type="text"
                  label="Ramal:"
                  {...field}
                  value={(field.value = contactRamal)}
                  onChange={(e) => {
                    // remover letras
                    const regex = /^[0-9]+$/;
                    if (!e.target.value.match(regex) && e.target.value !== '') {
                      return;
                    }
                    setContactRamal(e.target.value);
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    field.onBlur(field.onChange(e.target.value));
                  }}
                  error={!!errors?.extension?.message}
                  helperText={errors?.extension?.message}
                  fullWidth
                  inputProps={{ maxLength: 8 }}
                  sx={{ minWidth: '110px' }}
                />
              )}
            />
          </InputContainerWidthNumber>
        </FieldsInLineLayout>
        {alternativeContact && (
          <>
            <br />
            <SectionTitleContainer>
              <SectionTitle className="titleContactResponsive">
                Contato alternativo
              </SectionTitle>
              <FixedButton
                type="button"
                onClick={(e) => {
                  setAlternativeContact(!alternativeContact);
                  removeContactAlternative();
                }}
                variant="contained"
                className="btnResponsive"
              >
                Remover Contato Alternativo
              </FixedButton>
            </SectionTitleContainer>
            <FieldsInLineLayout className="lineResponsive">
              <Controller
                name="alternativeContactName"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactName?.message}
                    helperText={errors?.alternativeContactName?.message}
                    id="alternative_contact_name"
                    label={isRequiredAlternativeContact ? 'Nome *' : 'Nome'}
                    type="text"
                    fullWidth
                    value={(field.value = alternativeContactName)}
                    onChange={(e) => {
                      const regex = /^[aA-zZ\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }
                      setAlternativeContactName(e.target.value.toUpperCase());
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      setAlternativeContactName(
                        e.target.value.toUpperCase().trim()
                      );
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase().trim())
                      );
                    }}
                    inputProps={{
                      maxLength: 256,
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                )}
              />
              <Controller
                name="alternativeContactEmail"
                control={control}
                render={({ field }) => (
                  <TextField
                    id="alternative_contact_mail"
                    label={isRequiredAlternativeContact ? 'E-mail *' : 'E-mail'}
                    {...field}
                    error={!!errors?.alternativeContactEmail?.message}
                    helperText={errors?.alternativeContactEmail?.message}
                    type="text"
                    value={(field.value = alternativeContactEmail)}
                    onChange={(e) => {
                      setAlternativeContactEmail(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setAlternativeContactEmail(e.target.value.toLowerCase());
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    fullWidth
                    inputProps={{ maxLength: 256 }}
                  />
                )}
              />
              <Controller
                name="alternativeContactPhone"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactPhone?.message}
                    helperText={errors?.alternativeContactPhone?.message}
                    id="alternativeContactPhone"
                    label={
                      isRequiredAlternativeContact
                        ? 'DDD + Telefone *'
                        : 'DDD + Telefone'
                    }
                    value={(field.value = alternativeContactPhone)}
                    onChange={(e) => {
                      setAlternativeContactPhone(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length > 14) {
                        $('#alternativeContactPhone').mask('(00) 00000-0009');
                      } else {
                        $('#alternativeContactPhone').mask('(00) 0000-00009');
                      }
                      field.onBlur(field.onChange(e.target.value));
                      setAlternativeContactPhone(e.target.value);
                    }}
                    fullWidth
                    inputProps={{ maxLength: 50 }}
                    className="telResponsive"
                  />
                )}
              />
              <InputContainerWidthNumber>
                <Controller
                  name="alternativeExtension"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={!!errors?.alternativeExtension?.message}
                      helperText={errors?.alternativeExtension?.message}
                      id="alternative_contact_ramal"
                      label="Ramal:"
                      fullWidth
                      value={(field.value = alternativeContactExtension)}
                      onChange={(e) => {
                        const regex = /^[0-9]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        setAlternativeContactExtension(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      onBlur={(e) => {
                        setAlternativeContactExtension(e.target.value);
                        field.onBlur(field.onChange(e.target.value));
                      }}
                      inputProps={{ maxLength: 50 }}
                      sx={{ minWidth: '110px' }}
                    />
                  )}
                />
              </InputContainerWidthNumber>
            </FieldsInLineLayout>
          </>
        )}
        {alternativeContact2 && (
          <>
            <br />
            <SectionTitleContainer className="titleContactResponsive">
              <SectionTitle>Contato alternativo</SectionTitle>
              <FixedButton
                type="button"
                onClick={() => {
                  setAlternativeContact2(!alternativeContact2);
                  removeContactAlternative2();
                }}
                variant="contained"
                className="btnResponsive"
              >
                Remover Contato Alternativo
              </FixedButton>
            </SectionTitleContainer>
            <FieldsInLineLayout className="lineResponsive">
              <Controller
                name="alternativeContactName2"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactName2?.message}
                    helperText={errors?.alternativeContactName2?.message}
                    id="alternative_contact_name2"
                    label={isRequiredAlternativeContact2 ? 'Nome *' : 'Nome'}
                    type="text"
                    fullWidth
                    value={(field.value = alternativeContactName2)}
                    onChange={(e) => {
                      const regex = /^[aA-zZ\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }
                      setAlternativeContactName2(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setAlternativeContactName2(
                        e.target.value.toUpperCase().trim()
                      );
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase().trim())
                      );
                    }}
                    inputProps={{
                      maxLength: 256,
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                )}
              />
              <Controller
                name="alternativeContactEmail2"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactEmail2?.message}
                    helperText={errors?.alternativeContactEmail2?.message}
                    id="alternative_contact_mail2"
                    label={
                      isRequiredAlternativeContact2 ? 'E-mail *' : 'E-mail'
                    }
                    type="email"
                    fullWidth
                    value={(field.value = alternativeContactEmail2)}
                    onChange={(e) => {
                      setAlternativeContactEmail2(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setAlternativeContactEmail2(e.target.value.toLowerCase());
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                  />
                )}
              />
              <Controller
                name="alternativeContactPhone2"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactPhone2?.message}
                    helperText={errors?.alternativeContactPhone2?.message}
                    id="alternativeContactPhone2"
                    label={
                      isRequiredAlternativeContact2
                        ? 'DDD + Telefone *'
                        : 'DDD + Telefone'
                    }
                    type="text"
                    fullWidth
                    value={(field.value = alternativeContactPhone2)}
                    onChange={(e) => {
                      setAlternativeContactPhone2(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length > 14) {
                        $('#alternativeContactPhone2').mask('(00) 00000-0009');
                      } else {
                        $('#alternativeContactPhone2').mask('(00) 0000-00009');
                      }
                      field.onBlur(field.onChange(e.target.value));
                      setAlternativeContactPhone2(e.target.value);
                    }}
                    inputProps={{ maxLength: 50 }}
                    className="telResponsive"
                  />
                )}
              />
              <InputContainerWidthNumber>
                <Controller
                  name="alternativeExtension2"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={!!errors?.alternativeExtension2?.message}
                      helperText={errors?.alternativeExtension2?.message}
                      id="alternative_contact_ramal2"
                      label="Ramal:"
                      fullWidth
                      value={(field.value = alternativeContactExtension2)}
                      onChange={(e) => {
                        const regex = /^[0-9]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        setAlternativeContactExtension2(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      inputProps={{ maxLength: 50 }}
                      sx={{ minWidth: '110px' }}
                    />
                  )}
                />
              </InputContainerWidthNumber>
            </FieldsInLineLayout>
          </>
        )}
      </Paper>

      <StepButtons nextFunction={handleSubmit(onNextStep)} />
    </form>
  );
};
